const allRouters = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/wx-login",
    name: "wx-login",
    title: "登录",
    component: () => import("@/views/login/wx-redirect"),
    meta: {
      requireAuth: false
    }
  },
  // 登录模块======================
  {
    path: "/login",
    name: "login",
    title: "登录",
    component: () => import("@/views/login/login"),
    meta: {
      requireAuth: false
    }
  },
  // 绑定设备======================
  {
    path: "/addEquip",
    name: "addEquip",
    title: "添加设备",
    component: () => import("@/views/member/addEquip/addEquip"),
    meta: {
      requireAuth: false
    }
  },
  // 绑定传感器======================
  {
    path: "/addCgq",
    name: "addCgq",
    title: "添加设备",
    component: () => import("@/views/member/addCgq"),
    meta: {
      requireAuth: false
    }
  }, {
    path: "/cgqSetting",
    name: "cgqSetting",
    title: "传感器设置属性页面",
    component: () => import("@/views/live/cgq_setting"),
    meta: {
      requireAuth: false
    }
  },

  // 注册模块======================
  {
    path: "/register",
    name: "register",
    title: "注册",
    component: () => import("@/views/login/register/register"),
    meta: {
      requireAuth: false
    }
  },

  {
    path: "/forgot",
    name: "forgot",
    title: "忘记密码",
    component: () => import("@/views/login/forgot"),
    meta: {
      requireAuth: false
    }
  },

  // 走势图======================
  {
    path: "/trend",
    name: "trend",
    title: "trend",
    component: () => import("@/views/trend/trend.vue"),
    meta: {
      requireAuth: false
    }
  },
  // 导出======================
  {
    path: "/export",
    name: "export",
    title: "导出",
    component: () => import("@/views/export/export"),
    meta: {
      requireAuth: true
    }
  },
  // 阀门======================
  {
    path: "/valva",
    name: "valva",
    title: "阀门",
    component: () => import("@/views/valva/valva"),
    meta: {
      requireAuth: true
    }
  },
  // 任务列表======================
  {
    path: "/tasklist",
    name: "tasklist",
    title: "任务列表",
    component: () => import("@/views/valva/tasklist"),
    props: true,
    meta: {
      requireAuth: true
    }
  },
  // 实况======================
  {
    path: "/live",
    name: "live",
    title: "实况",
    component: () => import("@/views/live/live.vue"),
    // component: () => import('@/views/live/diyLive.vue'),

    meta: {
      requireAuth: true
    }
  },
  {
    path: "/liveSetting",
    name: "liveSetting",
    title: "设置",
    component: () => import("@/views/live/setting"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/fmError",
    name: "fmError",
    title: "阀门异常记录",
    component: () => import("@/views/live/setting/error"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/gatewayLog",
    name: "gatewayLog",
    title: "阀门登录记录",
    component: () => import("@/views/live/gatewayLog"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/pictures",
    name: "pictures",
    title: "二代气象站的摄像头图片列表",
    component: () => import("@/views/live/pictures"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/camera",
    name: "camera",
    title: "二代气象站设备信息",
    component: () => import("@/views/live/camera"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/videoPlay",
    name: "单独播放的监控页面",
    title: "视频监控",
    // component: () => import("@/views/live/videoPlay"),
    component: () => import("@/views/live/videoPlay/videoPlayYS.vue"),
    meta: {
      requireAuth: true
    }
  },
  // 我的======================
  {
    path: "/member",
    name: "member",
    title: "我的",
    component: () => import("@/views/member/member"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/member/message",
    name: "member/message",
    title: "消息",
    component: () => import("@/views/member/message"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/debug",
    name: "debug",
    title: "RTU日志",
    component: () => import("@/views/member/debug"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/changepwd",
    name: "changepwd",
    title: "修改密码",
    component: () => import("@/views/member/changepwd"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/openWxPush",
    name: "openWxPush",
    title: "开启微信通知",
    component: () => import("@/views/member/openWxPush"),
    meta: {
      requireAuth: true
    }
  },
  // 轮灌设置======================
  {
    path: "/lunGuan",
    name: "lunGuan",
    title: "轮灌设置",
    component: () => import("@/views/lunGuan"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/groupList",
    name: "groupList",
    title: "轮灌_列表",
    // component: () => import('@/views/lunGuan/group/list'),
    component: () => import("@/views/lunGuanV2/group/index"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/groupList3",
    name: "groupList",
    title: "轮灌_列表",
    component: () => import("@/views/lunGuanV3/group/index"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/groupAdd",
    name: "addGroup",
    title: "轮灌_添加分组",
    component: () => import("@/views/lunGuan/group/add"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/programList",
    name: "program",
    title: "轮灌程序",
    component: () => import("@/views/lunGuanV2/program/index"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/programList3",
    name: "program",
    title: "轮灌程序",
    component: () => import("@/views/lunGuanV3/program/index"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/programAdd",
    name: "addProgram",
    title: "添加轮灌程序",
    component: () => import("@/views/lunGuan/program/add"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/programErr",
    name: "programErr",
    title: "轮灌程序异常阀门日志",
    component: () => import("@/views/lunGuan/program/error"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/diseasesPests/:url?",
    name: "diseasesPests",
    title: "病虫害识别",
    component: () => import("@/views/member/diseasesPests"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/identifyRelut/:result",
    name: "identifyRelut",
    title: "病虫害识别",
    component: () => import("@/views/member/identifyRelut"),
    meta: {
      requireAuth: false
    }
  },
  //=============== AI识别图片 病虫害 ===================
  {
    path: "/ai",
    name: "ai",
    title: "AI识别",
    component: () => import("@/views/live/ai/index"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/ai/grow",
    name: "grow",
    title: "生长发育识别",
    component: () => import("@/views/live/ai/grow"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/ai/ndvi",
    name: "ndvi",
    title: "ndvi",
    component: () => import("@/views/live/ai/ndvi"),
    meta: {
      requireAuth: true
    }
  },

  // {
  //   path: "/rtu_program_main",
  //   name: "rtu_program_main",
  //   title: "rtu_program_main",
  //   component: () => import("@/views/programRTU/main/index.vue"),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: "/rtu_program_program",
    name: "rtu_program_program",
    title: "rtu_program_program",
    component: () => import("@/views/live/programRTU/program/index.vue"),
    meta: {
      requireAuth: true
    }
  },

  {
    path: "/newLive",
    name: "newLive",
    title: "newLive",
    component: () => import("@/views/newLive/live.vue"),
    meta: {
      requireAuth: true
    }
  },
  // 嵌入中化APP的页面
  {
    path: "/h5/device",
    name: "h5Device",
    title: "h5Device",
    component: () => import("@/views/h5Device/index.vue"),
    meta: { requireAuth: true }
  },
  {
    path: "/tokenExpire",
    name: "tokenExpire",
    title: "tokenExpire",
    component: () => import("@/views/tokenExpire/index.vue"),
    meta: { requireAuth: true }
  },

  {
    path: '/videoPlayComSetting', // type === 5  萤石摄像头控制页 设置拍照任务
    name: "videoPlayComSetting",
    title: "videoPlayComSetting",
    component: () => import("@/views/live/root_setting/taskSetting.vue"),
    meta: { requireAuth: true }
  },

  {
    path: '/videoPlayComPartData', // type === 5  萤石摄像头控制页 局部数据
    name: "videoPlayComPartData",
    title: "videoPlayComPartData",
    component: () => import("@/views/live/root_setting/partData.vue"),
    meta: { requireAuth: true }
  },
  {
    path: '/videoPlayComDetail', // type === 5  萤石摄像头控制页 局部数据
    name: "videoPlayComDetail",
    title: "videoPlayComDetail",
    component: () => import("@/views/live/root_setting/detail.vue"),
    meta: { requireAuth: true }
  },

  {
    path: '/view', // type === 5  萤石摄像头控制页 局部数据
    name: "view",
    title: "view",
    component: () => import("@/views/singleView"),
    meta: { requireAuth: true }
  },
  {
    path: '/yuanlinkongzhiqi',
    name: "yuanlinkongzhiqi",
    title: "yuanlinkongzhiqi",
    component: () => import("@/views/live/components/yuanLinKongZhiQi/programTrans.vue"),
    meta: { requireAuth: true }
  },
  {
    path: '/groupList4',
    name: "groupList4",
    title: "groupList4",
    component: () => import("@/views/live/components/yuanLinKongZhiQi/groupTrans.vue"),
    meta: { requireAuth: true }
  },
  {
    path: "/programList4",
    name: "programList4",
    title: "轮灌程序V3-5",
    component: () => import("@/views/live/components/yuanLinKongZhiQi/procedureTrans.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/irrigationStaticLog',
    name: "irrigationStaticLog",
    title: "灌溉统计查询",
    component: () => import("@/views/live/gatewayLog/irrigationStaticLog.vue"),
    meta: {
      requireAuth: false
    }
  }
];
export const routers = [...allRouters];
